/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const topSearchIndex = {
    queryPhrase: "",
    sortOptions: [],
    filterOptions: [
        { attribute: "visibility", in: ["Catalog", "Catalog, Search"] },
        { attribute: "inStock", eq: "true" }
    ],
    liveSearchProducts: [],
    liveSearchSuggestions: [],
    liveSearchCategories: [],
    init() {
        this.sortOptions = [
            { attribute: "department", direction: this.getGenderSort() },
            { attribute: "relevance", direction: "DESC" }
        ];
    },
    getGenderSort() {
        const genderCookie = hyva.getCookie("mey-gender");
        return (genderCookie === "m") ? "DESC" : "ASC";
    }
}

export default topSearchIndex;
